import './App.css'
import './styles/globals.css'
import { FC, useEffect, useState } from 'react'
import { Route, Routes, useSearchParams } from 'react-router-dom'
import { LeaderBoard } from './features'
import { appCallbackHandler } from './util/AppCallbackHandler'
import { Spinner } from './components'

const App: FC<unknown> = () => {
    const [searchParams] = useSearchParams()
    const queryToken = searchParams.get('token')
    const queryUserId = searchParams.get('userId')

    const [token, setToken] = useState<string | null>(
        localStorage.getItem('token')
    )

    const [futureUserApId, setFutureUserApId] = useState<string | null>(
        localStorage.getItem('FUTURE_USER_ID')
    )

    const [isUserAuthenticated, setIsUserAuthenticated] =
        useState<boolean>(false)

    const [isInterfaceLoading, setIsInterfaceLoading] = useState<boolean>(false)

    useEffect(() => {
        // Store token and userId from query params if they exist
        if (queryToken) {
            window.localStorage.setItem('token', queryToken)
            setToken(queryToken) // Update token state
        }
        if (queryUserId) {
            window.localStorage.setItem('FUTURE_USER_ID', queryUserId)
        }
    }, [queryToken, queryUserId])

    const pageIsLoaded = () => {
        appCallbackHandler('pageIsLoaded')
        console.log('pageIsLoaded method called')
    }

    const sendMobilPageIsLoadedHandler = () => {
        setTimeout(() => pageIsLoaded(), 1000)
    }

    useEffect(() => {
        if (window !== undefined) {
            sendMobilPageIsLoadedHandler()
            console.log(window, 'window is loaded')
        }
    }, [])

    useEffect(() => {
        // Check authentication status when token changes
        if (!token) {
            setIsUserAuthenticated(false)
        } else {
            setIsUserAuthenticated(true)
        }
    }, [token])

    useEffect(() => {
        if (futureUserApId) {
            window.localStorage.setItem('FUTURE_USER_ID', futureUserApId)
        }
    }, [futureUserApId])

    useEffect(() => {
        window.setTokenId = setNewAccessToken
        window.setAppUserId = setNewAppUserId
        window.setTransparentBackground = setTransparentBackground
    }, [])

    const setNewAccessToken = (newToken: string) => {
        window.localStorage.setItem('token', newToken)
        setToken(newToken)
        window.localStorage.setItem('APP', 'true')

        if (token) {
            setIsUserAuthenticated(true)
            console.log('USER is authenticated, token id comes from Mobile APP')
        } else {
            console.log('token is not received from Mobile')
        }
    }

    const setNewAppUserId = (futureUserId: string) => {
        window.localStorage.setItem('FUTURE_USER_ID', futureUserId)
        console.log(futureUserId, 'FUTURE_USER_ID comes from Mobile APP')
    }

    const setTransparentBackground = (transparent: boolean) => {
        window.localStorage.setItem('TRANSPARENT', 'transparent')
        console.log(transparent, 'transparent  comes from Mobile APP')
    }

    const allowedOrigins = [
        'https://revamped-trade.bitazza-staging.com',
        'https://trade.bitazza.com',
        'http://localhost:3000',
        'https://preprod-revamped-trade.bitazza.com',
    ]
    // Set the correct target origin based on environment
    const targetOrigin = allowedOrigins.includes(window.location.origin)
        ? window.location.origin
        : 'https://trade.bitazza.com' // Default

    useEffect(() => {
        const receiveMessage = (event: MessageEvent) => {
            if (allowedOrigins.includes(event.origin) && event.data?.token) {
                console.log('Token received in iframe:', event.data.token)
                localStorage.setItem('token', event.data.token)
                localStorage.setItem('FUTURE_USER_ID', event.data.userId)
                setToken(event.data.token)
                setFutureUserApId(event.data.userId)

                console.log(event.origin, 'event.origin')
                // Confirm receipt to parent
                window.parent.postMessage({ tokenReceived: true }, event.origin)
            }
        }

        window.addEventListener('message', receiveMessage)

        // Request token if not received
        window.parent.postMessage({ requestToken: true }, targetOrigin)

        if (!localStorage.getItem('token')) {
            console.log('🔄 Requesting token from parent...')
            window.parent.postMessage({ requestToken: true }, '*')
        }

        return () => window.removeEventListener('message', receiveMessage)
    }, [])

    return (
        <>
            {!isUserAuthenticated || isInterfaceLoading ? <Spinner /> : null}
            {isUserAuthenticated && (
                <Routes>
                    <Route
                        path="/"
                        element={
                            <LeaderBoard
                                isLeaderBoardLoading={(value) =>
                                    setIsInterfaceLoading(value)
                                }
                            />
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <main style={{ padding: '1rem' }}>
                                <p>There's nothing here!</p>
                            </main>
                        }
                    />
                </Routes>
            )}
        </>
    )
}

export default App
